module.exports = __webpack_public_path__ + "components/country-flag/static/cp-088d3c9402e57e4c9e38642920a960f2.svg";